
<template>

    <div class="Iteam AppendStyle" >
        
        <router-link :to="{path:'/soft', query: { id: data2.tittle }}">
            
            <!-- <img class="Image" src="../../assets/1.png"> -->
            <img class="Image" v-bind:src="'data:image/png;base64,' + data2.image" >

            <div class="PosTittle">
                <strong>{{data2.tittle}}</strong>
            </div>
            <div class="PosContent">
                {{data2.content | contentFormat(54)}}
            </div>
            <div class="PosSize">
                {{data2.size}}
            </div>
            
        </router-link>
            
        <router-link :to="{path:'/soft', query: { id: data2.tittle }}" v-if='data2.link=="" || data2.link==undefined'>
            <div class="PosButton" >
                详情
            </div>
        </router-link>
        <a class="PosButton decoration" :href="data2.link" v-else>
            打开
        </a>

    </div>

</template>

<script>
export default {
  name: 'Empty',
  props: {
    // soft: String,
    data2: {},
  },
  data () {
    return {
      visible: true,
      msg: 'Welcome to Your Vue.js App',
    }
  },

  filters: {

    contentFormat(content, len)
    {
        if(content.length > len)
        {
            return content.substring(0, len) + '...';
        }
        else return content;
    }
  },

  mounted()
  {
    // this.soft = this.$route.params.soft;
  },
  created()
  {
    // this.soft = this.$route.query.id;
    // this.$router.push({ path: '/soft', query: { id: 'easyicon' }});

    // this.soft = this.$route.params.id;
    // this.$router.push({ name: '/soft', params: { id: 'easyicon' }});
    

    // var that = this;
    // // this.$http.get('http://localhost:44923/pages/NoteInfo.aspx?soft=easyicon')
    // this.$http.get('/pages/NoteInfo.aspx', {params:{soft: this.soft}})
    // .then((response)=>{
    //   // console.log(response);
    // })
    // .catch((response)=>{
    //     console.log(response);
    // })

  },

  methods: {
    
    // // string转为base64
    // stringToBase64(str) {
    //   return new Buffer.from(str).toString("base64");
    // },

    // // base64转字符串
    // base64ToString(b64) {
    //   return new Buffer.from(b64, "base64").toString();
    // },

  }

}
</script>

<style scoped>

    .AppendStyle{
        margin-left: 20px;
        margin-right: 20px;
        margin-top: 1px;
    }
    .Iteam
    {
        position:relative;
        text-align:left;

        display:inline-block;
        width:556px;
        height:60px;
        padding:10px;
        margin-right:1px;
        color:#000000;
        background-color: white;
        border-bottom: 1px solid #ccc;
        /* border: 1px solid #ccc; */
        top: 0px;
        left: 0px;
        /* border-left-style: none;
        border-left-color: inherit;
        border-left-width: 1px;
        border-right-style: none;
        border-right-color: inherit;
        border-right-width: 1px;
        border-top-style: none;
        border-top-color: inherit;
        border-top-width: 1px; */
        border-width: 1px;
    }
    .Iteam:hover{
        background-color: #abd8cd;
    }
    .Image
    {
        width:60px;
        height:60px;
        border:1px;
        color:#ff0000;
    }
    .PosTittle
    {
        position:absolute;
        top: 12px;
        left: 80px;
        width: 300px;
        right: 131px;
        height: 24px;
        vertical-align: middle;
        color: #222222;
    }
    .PosContent
    {
        position:absolute;
        top: 36px;
        left: 80px;
        width: 320px;
        right: 132px;
        height: 24px;
        vertical-align: middle;
        color: #888888;
        font-size: 12px;
    }
    .PosSize
    {
        position:absolute;
        top: 29px;
        left: 407px;
        width: 75px;
        right: 119px;
        text-align:center;
        height: 27px;
        vertical-align: middle;
        color: #222222;
    }
    .PosButton
    {
        position:absolute;
        top: 27px;
        left: 495px;
        width: 60px;
        height: 24px;
        /* right: 31px; */
        border-radius: 5px;

        text-align:center;
        vertical-align: middle;
        
        border: 1px solid gray;
        background-color: #e9686b;

        color: white;
    }
    .PosButton:hover
    {
        /* background-color: #f582ae; */
        background-color: rgb(255,105,143);
    }
    .decoration{
        text-decoration: none;
    }

</style>


// WEBPACK FOOTER //
// src/components/control/SoftIteam.vue